import React from 'react';
import {
    Box, TextField, IconButton, InputAdornment, Paper,
    Typography, CircularProgress,
} from '@mui/material';
import { Search, Clear, KeyboardArrowDown, ErrorOutlined as ErrorOutline } from '@mui/icons-material';
import { ClickAwayListener } from '@mui/material';

const MissionSearchBar = ({
    searchText,
    setSearchText,
    dropdownOpen,
    setDropdownOpen,
    filteredMissions,
    missionsLoading,
    missionsError,
    jobUuid,
    onSelectMission,
    onLoadMissions,
    onClear,
}) => {
    return (
        <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
            <Box sx={{ flex: 1, position: 'relative' }}>
                <TextField
                    fullWidth
                    placeholder="Rechercher une mission active…"
                    variant="outlined"
                    size="small"
                    value={searchText}
                    onFocus={() => { setDropdownOpen(true); onLoadMissions(); }}
                    onChange={(e) => { setSearchText(e.target.value); setDropdownOpen(true); }} slotProps={{ input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search sx={{ color: '#adb5bd', fontSize: '1.1rem' }} />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                {searchText ? (
                                    <IconButton aria-label="Effacer la recherche" size="small" onClick={onClear}>
                                        <Clear fontSize="small" sx={{ color: '#adb5bd' }} />
                                    </IconButton>
                                ) : (
                                    <KeyboardArrowDown sx={{ color: '#adb5bd', fontSize: '1.1rem' }} />
                                )}
                            </InputAdornment>
                        ),
                        sx: { borderRadius: '10px', backgroundColor: '#fff', fontSize: '0.85rem', height: 40 }
                    } }}
                />
                
                {dropdownOpen && (
                    <Paper elevation={4} sx={{
                        position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 9999,
                        maxHeight: 260, overflowY: 'auto', mt: 0.5, borderRadius: 2,
                        border: '1px solid #e2e8f0'
                    }}>
                        {missionsLoading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                                <CircularProgress size={22} />
                            </Box>
                        ) : missionsError ? (
                            <Box sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1, color: '#dc3545' }}>
                                <ErrorOutline fontSize="small" />
                                <Typography variant="body2">{missionsError}</Typography>
                            </Box>
                        ) : filteredMissions.length === 0 ? (
                            <Typography variant="body2" sx={{ p: 2, color: '#adb5bd', textAlign: 'center' }}>
                                Aucune mission trouvée
                            </Typography>
                        ) : (
                            filteredMissions.map((mission, idx) => {
                                const titre = mission.value || mission.id;
                                const societe = mission.nom_societe || '';
                                const isSelected = mission.id === jobUuid;
                                return (
                                    <Box
                                        key={mission.id || idx}
                                        onClick={() => onSelectMission(mission)}
                                        sx={{
                                            px: 2, py: 1, cursor: 'pointer',
                                            backgroundColor: isSelected ? '#f0f7fd' : '#fff',
                                            borderLeft: isSelected ? '3px solid #03407b' : '3px solid transparent',
                                            '&:hover': { backgroundColor: '#f0f7fd' },
                                            borderBottom: '1px solid #f0f0f0',
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2c3e50', lineHeight: 1.3 }}>
                                            {titre}
                                        </Typography>
                                        {societe && (
                                            <Typography variant="caption" sx={{ color: '#adb5bd' }}>
                                                {societe}
                                            </Typography>
                                        )}
                                    </Box>
                                );
                            })
                        )}
                    </Paper>
                )}
            </Box>
        </ClickAwayListener>
    );
};

export default MissionSearchBar;
